import createTypeDecorator from '../decorators/createTypeDecorator'

export const TAGS = Symbol("schemer.types.TAGS")

export const tags = createTypeDecorator(TAGS, {
  formatDisplay: val => val && Array.isArray(val) && val.length > 0 ? val.join(', ') : "",
  table: {
    width: 400
  }
})
